// import React, { createContext, useContext, useState, useEffect } from "react";

// // Create the CartContext
// const CartContext = createContext();

// // Custom hook to use CartContext
// export const useCart = () => {
//     return useContext(CartContext);
// };

// // CartContext Provider
// export const CartProvider = ({ children }) => {
//     const [cartItems, setCartItems] = useState([]);

//     // Load cart items from localStorage when the app starts
//     useEffect(() => {
//         const storedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
//         setCartItems(storedCart);
//     }, []);

//     // Save cart items to localStorage whenever they change
//     useEffect(() => {
//         localStorage.setItem("cartItems", JSON.stringify(cartItems));
//     }, [cartItems]);

//     // Add an item to the cart
//     const addToCart = (item) => {
//         const existingItemIndex = cartItems.findIndex(
//             (cartItem) => cartItem.id === item.id && cartItem.sizeId === item.sizeId
//         );

//         if (existingItemIndex > -1) {
//             // Update quantity if the item already exists
//             const updatedCart = [...cartItems];
//             updatedCart[existingItemIndex].quantity += item.quantity;
//             setCartItems(updatedCart);
//         } else {
//             // Add new item to the cart
//             setCartItems([...cartItems, item]);
//         }
//     };

//     // Remove an item from the cart
//     const removeFromCart = (id, sizeId) => {
//         const updatedCart = cartItems.filter(
//             (cartItem) => !(cartItem.id === id && cartItem.sizeId === sizeId)
//         );
//         setCartItems(updatedCart);
//     };

//     // Clear the cart
//     const clearCart = () => {
//         setCartItems([]);
//     };

//     return (
//         <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart }}>
//             {children}
//         </CartContext.Provider>
//     );
// };

import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const useCart = () => {
    return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
    // Initialize state from localStorage if available
    const [cartItems, setCartItems] = useState(() => {
        try {
            const savedCart = localStorage.getItem("cartItems");
            console.log("saver",savedCart);
            return savedCart ? JSON.parse(savedCart) : [];
        } catch (error) {
            console.error("Error loading cart from localStorage:", error);
            return [];
        }
    });

    // Update localStorage whenever cart changes
    useEffect(() => {
        try {
            localStorage.setItem("cartItems", JSON.stringify(cartItems));
        } catch (error) {
            console.error("Error saving cart to localStorage:", error);
        }
    }, [cartItems]);

    const addToCart = (item) => {
        setCartItems(prevItems => {
            const existingItemIndex = prevItems.findIndex(
                (cartItem) => cartItem.id === item.id && cartItem.sizeId === item.sizeId && cartItem.aroma===item.aroma
            );

            if (existingItemIndex > -1) {
                const updatedItems = [...prevItems];
                updatedItems[existingItemIndex].quantity += item.quantity;
                return updatedItems;
            } else {
                return [...prevItems, item];
            }
        });
    };

    const removeFromCart = (id, sizeId) => {
        setCartItems(prevItems => 
            prevItems.filter(cartItem => !(cartItem.id === id && cartItem.sizeId === sizeId))
        );
    };

    const clearCart = () => {
        setCartItems([]);
    };

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            clearCart
        }}>
            {children}
        </CartContext.Provider>
    );
};